
  import React from "react"
  import Component from "/opt/build/repo/src/layouts/layout.tsx"
  import data from "/opt/build/repo/.cache/json/layout-layout.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/layout.js